<script setup>
import { ref } from 'vue'

import { chatDraftKindEnum, useChatStore } from '@/stores/chat.store'
import { useWebSiteStore } from '@/stores/web-site.store'
import { useDetectDevice } from '@/composables/device'

import ProjectEdit from '@/components/shared/ProjectEdit.vue'
import BudgetDocumentEdit from '@/components/accounting/BudgetDocumentEdit.vue'
import ChatConversation from '@/components/chat/ChatConversation.vue'
import ChatFormDialog from '@/components/chat/ChatFormDialog.vue'
import DockablePanel from '@/components/shared/dockable-panel/DockablePanel.vue'

const chatStore = useChatStore()
const webSiteStore = useWebSiteStore()
const { isMobile } = useDetectDevice()

const form = ref(null)

const openDraftForm = (message) => { form.value = chatStore.getDraftForm(message) }

const onCreated = async(item) => {
  const { message } = form.value
  form.value = null
  await chatStore.markDraftCreatedAsync(message, item.id)
}
</script>

<template>
  <dockable-panel
    v-model="chatStore.showChat"
    v-model:width="webSiteStore.chatPanelWidth"
    v-model:bounds="webSiteStore.chatWindowBounds"
    :docked="webSiteStore.chatPanelDocked"
  >
    <template #default="{ floating, move }">
      <chat-conversation :floating="floating" @move="move" @open-draft="openDraftForm" />
    </template>
  </dockable-panel>

  <chat-form-dialog />

  <q-dialog
    :model-value="form !== null"
    :maximized="isMobile"
    class="dialog-sm"
    @hide="form = null"
  >
    <template v-if="form">
      <project-edit
        v-if="form.kind === chatDraftKindEnum.PROJECT"
        :model-value="form.item"
        :initial-service-ids="form.serviceIds"
        :initial-contact-references="form.contactReferences"
        @update="onCreated"
        @cancel="form = null"
        @delete="form = null"
      />
      <budget-document-edit
        v-else
        :model-value="form.item"
        :initial-contact-references="form.contactReferences"
        @update="onCreated"
        @cancel="form = null"
        @delete="form = null"
      />
    </template>
  </q-dialog>
</template>
